module.exports = __webpack_public_path__ + "img/boston-party-2.b18b7c14.jpeg";